/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageProductTransferAdminPageResponse } from '../../models/page-product-transfer-admin-page-response';

export interface GetProductTransferRequests$Params {

/**
 * Search on the transfer type
 */
  transferRequesterType?: 'MANUFACTURER' | 'IMPORTER';

/**
 * Search on packaging unit label
 */
  packagingUnitLabel?: string;

/**
 * Search on the name of the from merchant
 */
  fromMerchantName?: string;

/**
 * Search on the name of the to merchant
 */
  toMerchantName?: string;

/**
 * Zero-based page index (0..N)
 */
  page?: number;

/**
 * The size of the page to be returned
 */
  size?: number;

/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
  sort?: Array<string>;
}

export function getProductTransferRequests(http: HttpClient, rootUrl: string, params?: GetProductTransferRequests$Params, context?: HttpContext): Observable<StrictHttpResponse<PageProductTransferAdminPageResponse>> {
  const rb = new RequestBuilder(rootUrl, getProductTransferRequests.PATH, 'get');
  if (params) {
    rb.query('transferRequesterType', params.transferRequesterType, {});
    rb.query('packagingUnitLabel', params.packagingUnitLabel, {});
    rb.query('fromMerchantName', params.fromMerchantName, {});
    rb.query('toMerchantName', params.toMerchantName, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageProductTransferAdminPageResponse>;
    })
  );
}

getProductTransferRequests.PATH = '/products/transfers';
